<div class="form-group add-jsn-room">
    <label>{{filter.displayname}}<span class="required-text" *ngIf="filter.required">*</span></label>
    <ng-select *ngIf="datatype == 6" [className]="'jsn-select'" [placeholder]="'Select ' + filter.displayname"
        [multiple]="true" [items]="options" [bindLabel]="'name'" [closeOnSelect]="false" [(ngModel)]="selectedValue"
        (ngModelChange)="onSelectionChange($event)" class="custom-ng-select">

        <ng-template ng-header-tmp>
            <div class="d-flex align-items-center p-2">
                <input type="checkbox" (change)="toggleSelectAll('project', $event)"
                    [checked]="isAllSelected('project')" class="mr-2" id="selectAll-{{filter?.id}}" />
                <label for="selectAll-{{filter?.id}}" class="mb-0 cursor-pointer">Select All</label>
            </div>
        </ng-template>

        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label"> {{item.name}}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>

        <ng-template ng-optgroup-tmp let-item="item">
            <div class="custom-group">
                <strong> {{ item.name }}</strong>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="d-flex align-items-center">
                <input type="checkbox" [checked]="isSelected('JSN', item)" class="mr-2" />
                {{ item.name }}
            </div>
        </ng-template>
    </ng-select>

    <div *ngIf="datatype != 6">
        <select class="p-2 w-100" [(ngModel)]="selectedValue" (ngModelChange)="onSelectionChange($event)">
            <option *ngIf="showAll" selected [value]="emptyGuid">All</option>
            <option *ngFor="let option of options" [value]="option.id">{{option.name}}</option>
        </select>
    </div>
</div>